import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'reset-pw-form',
  templateUrl: './reset-pw-form.component.html',
  styleUrls: ['./reset-pw-form.component.scss']
})
export class ResetPwFormComponent implements OnInit {
  @Output() hideResetForm = new EventEmitter();

  resetForm: FormGroup;
  showMessage: boolean = false;

  constructor(private formBuilder: FormBuilder,
    private _user: UserService) { }

  ngOnInit() {
    this.initResetForm();
  }

  initResetForm() {
    this.resetForm = this.formBuilder.group({
      email: ['', Validators.email]
    });
  }

  backToSignin() {
    this.hideResetForm.emit(true);
  }

  sendRequest() {
    if (!this.resetForm.valid) return;
    let email = this.resetForm.value.email;
    this._user.forgotPw(email).then((data: any) => {
      this.showMessage = true;
    }).catch((err) => {
      console.log(err);

    })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reset-pw-form/reset-pw-form.component.ts